"use client";

import { CalendarHeart, ChefHat, ShoppingBag, Utensils } from "lucide-react";
import type React from "react";
import type { FooterExperienceCard } from "@/types";

export interface FooterExperienceProps {
  cards: FooterExperienceCard[];
}

const iconMap = {
  utensils: Utensils,
  "shopping-bag": ShoppingBag,
  "calendar-heart": CalendarHeart,
  "chef-hat": ChefHat,
};

const FooterExperience: React.FC<FooterExperienceProps> = ({ cards }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
      {cards.map((card) => {
        const IconComponent = iconMap[card.icon as keyof typeof iconMap];

        return (
          <div
            key={`${card.icon}-${card.title}`}
            className="text-center group cursor-pointer"
          >
            <div className="mb-4 overflow-hidden">
              <div className="w-full h-32 border border-black/10 flex items-center justify-center group-hover:border-black/20 transition-colors">
                {IconComponent && (
                  <IconComponent className="w-12 h-12 text-black/30 group-hover:text-black/50 transition-colors" />
                )}
              </div>
            </div>
            <h4 className="text-lg font-medium text-black mb-2 tracking-wide">
              {card.title}
            </h4>
            <p className="text-sm text-black/60 font-light">
              {card.description}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default FooterExperience;
